import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHeadset,
  faSignOutAlt
} from "@fortawesome/free-solid-svg-icons";
import styles from "./DoctorFooter.module.css";
import logoImg from "../../static/logo.png";

const DoctorFooter = ({ handleLogout }) => {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerInner}>
        {/* ─── 3 Column Grid Layout ──────────────────────────────────────── */}
        <div className={styles.mainGrid}>
          {/* Column 1: Brand & Provider Anchor */}
          <div className={styles.brandCol}>
            <Link to="/doctor-dashboard" className={styles.brandLogo}>
              <img src={logoImg} alt="ReformMe Logo" className={styles.logoImg} />
              <div className={styles.brandTextStack}>
                <span className={styles.brandTextTop}>ReformMe</span>
                <span className={styles.brandTextBottom}>HEALTHCARE</span>
              </div>
            </Link>
            <div className={styles.accentLine}></div>
            <p className={styles.providerStatement}>
              Clinical Management Portal. Empowering our practitioners with advanced tools to deliver precision physiotherapy and holistic wellness.
            </p>
          </div>

          {/* Column 2: Clinical Navigation */}
          <div>
            <h4 className={styles.colHeading}>CLINIC OPERATIONS</h4>
            <ul className={styles.navList}>
              <li><Link to="/doctor/dashboard" className={styles.navLink}>Today's Schedule</Link></li>
              <li><Link to="/doctor/slots" className={styles.navLink}>Slot Management</Link></li>
              <li><Link to="/doctor/messages" className={styles.navLink}>Patient Messages</Link></li>
              <li><Link to="/doctor/blogs" className={styles.navLink}>Blog Manager</Link></li>
            </ul>
          </div>

          {/* Column 3: Account & Support */}
          <div>
            <h4 className={styles.colHeading}>ACCOUNT & SUPPORT</h4>
            <ul className={styles.navList}>
              <li><Link to="/doctor/profile" className={styles.navLink}>Profile & Settings</Link></li>
            </ul>
            <div className={styles.supportItem}>
              <FontAwesomeIcon icon={faHeadset} className={styles.supportIcon} />
              <span>IT Support / Help Desk</span>
            </div>
            <button
              type="button"
              onClick={handleLogout}
              className={styles.logoutBtn}
            >
              <FontAwesomeIcon icon={faSignOutAlt} />
              <span>Secure Logout</span>
            </button>
          </div>
        </div>

        {/* ─── Bottom Bar (Internal Legal & Security) ────────────────────── */}
        <div className={styles.bottomBar}>
          <p className={styles.copyright}>
            © 2026 ReformMe Healthcare. Secure Provider Portal.
          </p>
          <div className={styles.bottomLinks}>
            <Link to="#" className={styles.bottomLink}>Staff Privacy Policy</Link>
            <Link to="#" className={styles.bottomLink}>System Terms of Use</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default DoctorFooter;
